<div class="recovery-component">
  <p>Awesome! A verification link was sent to {{email}}.</p><br>
  <text-field [width]="360" (inputChange)="newPassword=$event" [label]="'New Password'" [type]="'password'" [control]="password"></text-field>
  <text-field [width]="360" (inputChange)="confirmedPassword=$event" [label]="'Re-enter Your New Password'" [type]="'password'"></text-field>
  
  <div class="password-requirements">
    <p>Password requirements</p>
    <ul>
      <li>
        <mat-icon *ngIf="!password.value || password.value.length == 0 || password.getError('minlength'); else validLength;">radio_button_unchecked</mat-icon>
        <ng-template #validLength>
          <mat-icon class="valid">check_circle_outline</mat-icon>
        </ng-template>
        Minimum length of 8 characters
      </li>
      <li>
        <mat-icon *ngIf="!password.value || password.value.length == 0 || password.getError('upperCase'); else validUpper;">radio_button_unchecked</mat-icon>
        <ng-template #validUpper>
          <mat-icon class="valid">check_circle_outline</mat-icon>
        </ng-template>
        Contains an upper-case letter
      </li>
      <li>
        <mat-icon *ngIf="!password.value || password.value.length == 0 || password.getError('lowerCase'); else validLower;">radio_button_unchecked</mat-icon>
        <ng-template #validLower>
          <mat-icon class="valid">check_circle_outline</mat-icon>
        </ng-template>
        Contains a lower-case letter
      </li>
      <li>
        <mat-icon *ngIf="!password.value || password.value.length == 0 || password.getError('number'); else validNumber;">radio_button_unchecked</mat-icon>
        <ng-template #validNumber>
          <mat-icon class="valid">check_circle_outline</mat-icon>
        </ng-template>
        Contains a number
      </li>
    </ul>
  </div>

  <p class="warning-text">{{error}}<br></p>
  <button (click)="handleSubmit()" class="submit-btn" #submitButton>Set New Password</button>
  <p>Didn't receive a verification link? <a href="" (click)="handleResend()" class="login-link">Resend link</a>.</p>
</div>